import { Keys } from '../helpers/Keys';
import { Module } from '../Module';

Module.instance().directive('tbEnterSpaceEscapeDownOutside', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        const eventNamespace = '.tbEnterSpaceEscapeDownOutside' + scope.$id;
        const downOutsideFn = $parse(attr['tbEnterSpaceEscapeDownOutside']);
        const doc = angular.element(document);
        const keydownEvents = 'keydown' + eventNamespace;

        doc.on(keydownEvents, (downEvent: JQueryKeyEventObject) => {
          const key = downEvent && downEvent.which;
          if (key === Keys.Enter || key === Keys.Space || key === Keys.Escape) {
            const target = $(downEvent.target);
            if (target.closest(element).length === 0) {
              scope.$apply(() => {
                downOutsideFn(scope, { $event: downEvent });
              });
            }
          }
        });
        element.on('$destroy', () => {
          doc.off(eventNamespace);
        });
      }
    };
  }
]);
